import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import UrlManager from './../../model/UrlManager';
import CoreAjax from '../../util/CoreAjax';
import LoaderMask from '../../components/common/LoaderMask';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';
import RbUtil from './../../util/RbUtil';
import RbMeta from './../../util/RbMeta';
import RbTitle from './../../util/RbTitle';
import RbHeading from './../../util/RbHeading';
import TrackingManager from '../../model/event-structures';
import TimeUtil from '../../util/TimeUtil';
import HmEventRegistry from './../../model/HmEventRegistry';
import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
import UserStorageUtil from '../../util/UserStorageUtil';
import UserStore from '../../util/UserStore';
import browserStorageUtil from '../../util/BrowserStorageUtil';
import browserUtil from '../../util/BrowserUtil';
import AdsTracker from '../../util/AdsTracker';
import ComponentRegistry from '../../model/ComponentRegistry.js';
import ComponentHelper from '../../util/ComponentHelper';
import FileAppender from '../../util/FileAppender';

export default class CorePage extends React.Component{
	constructor(props) {
		super(props);
	}

	getQueryParams() {
		try{
			if(!window.location.href.includes("?")){
				return {};
			}
			var pairs =  window.location.href.split("?")[1].split('&');

			var result = {};
			pairs.forEach(function(pair) {
				pair = pair.split('=');
				result[pair[0]] = decodeURIComponent(pair[1] || '');
			});

			return JSON.parse(JSON.stringify(result));
		}catch(e){}

		return {};
	}

	getQueryParam(key=null){
		if(key){
			const qryParams = this.getQueryParams();

			return (qryParams && qryParams[key]) ? qryParams[key] : null;
		}

		return null;
	}

	appendJS(url){
	   new FileAppender(url).addVersion().js();
	}

	appendCSS(url){
	   new FileAppender(url).addVersion().css();
	}

	getCmpHelper(userStore){
		return ComponentHelper(userStore);
	}

	getTimeUtil(){
		return new TimeUtil();
	}

	getTracker(){
		return TrackingManager;
	}

	isMobile(){
		return isMobile;
	}

	isTab(){
		return isTablet;
	}

	isBrowser(){
		return isBrowser;
	}

	getSessionStore(){
		return UserStorageUtil;
	}

	saveInSession(key, value){
		UserStorageUtil.storeSessionItem(key, value);
	}

	getFromSession(key){
		return UserStorageUtil.getStoredSessionItem(key);
	}

	getAdsTracker(){
		return AdsTracker;
	}

	getTermsUrl(_geo){
		let geo = _geo || "ROW";
		let termsObj = window.termsandCondition;
		let termsURL = termsObj[geo] ? termsObj[geo] : termsObj["ALL"];
	    return termsURL;
	}

	getGeo(){
		if(sessionStorage.getItem("geo") && sessionStorage.getItem("geo").length > 0){
			return sessionStorage.getItem("geo");
		}

		return browserUtil.getCookie("geo");
	}

	prodForCountry(){
		let producttoShow = (window.producttoShow) ? window.producttoShow : null;
		let geoLocation =  this.getGeo();
		let prodShow = ''
		if(producttoShow){
			prodShow =  producttoShow[geoLocation] || producttoShow['OTHERS'];
		}else{
			prodShow =  'SG';
		}
		return prodShow;
	}

	sessionCheck(successCallback, failureCallBack, forceTrigger){
		
		var me = this;
		var success = function(userObj, opts){
			if(typeof successCallback === "function"){
				successCallback.apply(this, [userObj]);
			}
		}
		var failure = function(error, opts){
			if(typeof failureCallBack === "function"){
				failureCallBack.apply(this, [error]);
			}
		}

		if(forceTrigger || this.isSessionCheckEligible()){
			new CoreAjax(me.getUrlFor("SESSION_CHECK")).get(success,failure);	
			
			if(forceTrigger){
				browserStorageUtil.storeItem("LAST_SESSION_CHECK", ((new Date().getTime()) / 1000));
			}
		}else{
			var storedUserObj = this.getStoredUser();
			if(storedUserObj){
				if(typeof successCallback === "function"){
					successCallback.apply(this, [storedUserObj]);
				}
			}else{
				if(typeof failureCallBack === "function"){
					failureCallBack.apply(this, [{sessionChecked:false}]);
				}
			}
		}
	}

	isSessionCheckEligible(){
		let storedUser = this.getStoredUser();
		let storedUserId = (storedUser && storedUser.userId) ? storedUser.userId : null;

		if(!(storedUserId && storedUserId.length > 0)){
			return true;
		}		

		let DEFAULT_INTERVAL_IN_SECS = (!isNaN(window.sessionCheckInterval) && window.sessionCheckInterval > 0) ? window.sessionCheckInterval : 15;

		try{
			let dt = (new Date().getTime()) / 1000;
			let oldDt = browserStorageUtil.getStoredItem("LAST_SESSION_CHECK");

			if(!isNaN(oldDt) && (dt - oldDt) <= DEFAULT_INTERVAL_IN_SECS){
				return false;
			}else{
				browserStorageUtil.storeItem("LAST_SESSION_CHECK", dt);
			}
		}catch(e){}
		
		return true;
	}

	getStoredUser(){
		return this.getFromSession("USER_DETAILS");
	}

	setLocale(locale){
		RbUtil.setLocale(locale);
		RbMeta.setLocale(locale);
		RbTitle.setLocale(locale);
		RbHeading.setLocale(locale);
	}

	rb(rawTxt,replaceStringArray=[]){
		return RbUtil.getText(rawTxt,replaceStringArray);
	}

	getLocales(){
		return RbUtil.getLocales();
	}

	getTitle(rawTxt,replaceStringArray=[]){
		return RbTitle.getText(rawTxt,replaceStringArray);
	} 

	setTitle(rawTxt,replaceStringArray=[]){
		document.title=this.getTitle(rawTxt,replaceStringArray)
	}

	getMeta(rawTxt,replaceStringArray=[]){
		return RbMeta.getText(rawTxt,replaceStringArray);
	} 

	setMeta(rawTxt,replaceStringArray=[]){
		var me = this;
		//document.body.onload = ()=> {

			var metas = document.getElementsByTagName("meta");
			if(metas && metas.length > 0){
				for(var i=0; i < metas.length; i++){
					if(metas[i].name === "description"){
						var descMeta = metas[i];
						descMeta.content = me.getMeta(rawTxt,replaceStringArray);
					}				
				}
			} 
		//}
	}
	getHeading(rawTxt,replaceStringArray=[]){	
		return RbHeading.getText(rawTxt,replaceStringArray);
	} 
	
	
	setHeading(rawTxt,replaceStringArray=[]){
		var heading = document.getElementById("hidden-h1");
		heading.textContent = this.getHeading(rawTxt,replaceStringArray);		
		
	}

fireEvent(event, obj){
	if(event){
		HmEventRegistry.fireEvent(event, obj);
	}
}

getUrlFor(action){
	return UrlManager.getUrlForAction(action);
}

showLoader(){
	return(
		<div><LoaderMask /></div>
		)
	}


	showAlert(title,message, btnHandlers,btnshw = null,closeOnClickOutside=false){
		var me = this;

		var buttons = [];

		try{
			if(btnHandlers !== undefined && btnHandlers !== null && btnHandlers.length > 0){
				for(var i=0;i<btnHandlers.length; i++){
					buttons.push({
						label: btnHandlers[i].label || me.rb("btn.ok"),
						onClick: (typeof btnHandlers[i].handler === "function") ? btnHandlers[i].handler : () => {}
					})
				}
			}
		}catch(e){}

		if(buttons.length == 0 && btnshw == null){
			buttons.push({
				label: 'Ok',
				onClick: () => {}
			});
		}

		return confirmAlert({
			title: title || 'Alert',
			message: message ? ReactHtmlParser(message) : 'Hello..',
			buttons: buttons,
    		closeOnClickOutside : closeOnClickOutside || false
		}); 
	}

	removeWhiteSpace(str){
		return str.replace(/ +/g, "");
	}

	render() {
		return(
		<div><LoaderMask /></div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/views/core/CorePage.js